// components/TestRunner/rules/Rule07c_SOR_AntiCheat_HorsService.js
import { Rule07_SOR_AntiCheat_Shared } from "./Rule07_SOR_AntiCheat_Shared.js";

/**
 * Rule07c_SOR_AntiCheat_HorsService.js
 *
 * ✅ Règle 07c – Les fichiers SOR des fibres hors services doivent avoir une cohérence entre nommage externe et métadonnées internes
 * Type: Error
 *
 * 🧪 Tests effectués :
 * • Validation croisée position : RuleUtils.extractPositionFromName() vs cableId + numeroFibreOrigine
 * • Validation croisée longueur d'onde : nom vs metadata.wavelength vs longueurOndeConfirmation
 * • Validation cohérence PBO : nom vs métadonnées internes (avec gestion troncature Viavi)
 * • Validation cohérence position physique : nom vs métadonnées internes (avec gestion troncature Viavi)
 * • Détection anti-triche : fichiers renommés, erreurs configuration, manipulation données
 */

export class Rule07c_SOR_AntiCheat_NameVsMeta_HorsService {
  /**
   * Appliquer la règle 07c : Anti-triche nom vs métadonnées pour hors service
   * @param {Object} fiber - Objet fibre avec toutes ses données
   */
  static apply(fiber) {
    // Prérequis : Rule00 + Rule01 + Rule03 + Rule06a ont validé l'existence et format
    // Vérifier qu'on est dans un cas de PV Hors Service
    if (!fiber.hasPvHs) {
      return; // Règle ne s'applique qu'aux fibres avec PV hors service
    }

    // Déléguer la validation à la classe partagée
    const messages = Rule07_SOR_AntiCheat_Shared.validateFiles(fiber.pvHs.files, "R07c");

    // Traiter les messages selon leur niveau (error ou warning)
    messages.forEach((message) => {
      if (message.level === "warning") {
        this._addWarning(fiber, message.rule, message.title, message.message);
      } else {
        this._addError(fiber, message.rule, message.title, message.message);
      }
    });
  }

  /**
   * Ajouter une erreur au résultat d'une fibre
   */
  static _addError(fiber, rule, title, message) {
    if (!fiber.testResults) {
      fiber.testResults = {
        status: "success",
        hasError: false,
        messages: [],
      };
    }

    fiber.testResults.status = "error";
    fiber.testResults.hasError = true;
    fiber.testResults.messages.push({
      type: "error",
      rule,
      title,
      message,
    });
  }

  /**
   * Ajouter un avertissement au résultat d'une fibre (sans changer le status à "error")
   */
  static _addWarning(fiber, rule, title, message) {
    if (!fiber.testResults) {
      fiber.testResults = {
        status: "success",
        hasError: false,
        messages: [],
      };
    }

    // Pour un warning, on garde le status "success" et hasError à false
    // On ajouter juste le message avec type "warning"
    fiber.testResults.messages.push({
      type: "warning",
      rule,
      title,
      message,
    });
  }
}
